import {Component} from "react";
import React from "react";

/**
 * React component row item
 */
export class SubjectItem extends Component {

    constructor(props) {
        super(props);
        this.state = {selectedCourse: null};
    }

    onSelectCourse(e) {
        const {courses} = this.props;

        const index = e.target.selectedIndex;
        this.setState({
            selectedCourse : courses[index - 1]
        });
    }

    render() {
        let {courses, levels} = this.props;
        const selectedCourse = this.state.selectedCourse;
        let levelsSelect = null;

        // selectBox with total list of courses
        const coursesSelect = courses.map((course, key) => {
            return (
                <option key={key} index={key} value={course.id}>{course.name}</option>
            );
        });

        // selectBox available levels depending on selected course
        if(selectedCourse) {
            levelsSelect = levels.filter(level =>
                selectedCourse.minTutorLevel <= level.id &&
                level.id <= selectedCourse.maxTutorLevel
            ).map((level, key) => (<option key={key} value={level.id}>{level.label}</option>));
        }

        return (
            <li className="c-form-step__row row">
                <div className="col-md p-1">
                    <select name="courses[]"
                            className="mx-1 ui-input ui-select"
                            defaultValue="disabled"
                            onChange={(e) => this.onSelectCourse(e)}
                            required>
                        <option value="disabled" disabled={true}>Selecteer vak...</option>
                        {coursesSelect}
                    </select>
                </div>
                <div className="col-md p-1">
                    <select name="levels[]" className="mx-1 ui-input ui-select" defaultValue="disabled" required>
                        {selectedCourse && levelsSelect.length > 1 &&
                        <option value="disabled" disabled={true}>Selecteer niveau...</option>
                        }
                        {!selectedCourse &&
                        <option value="disabled" disabled={true}>Selecteer eerst een vak...</option>
                        }
                        {levelsSelect}
                    </select>
                </div>
            </li>
        );
    }
}
